import React from 'react';
import { Divider as AntDivider } from 'antd';

/**
 * Componente de Divider
 * @param {string} orientation - Orientação do divider (left, center, right)
 * @param {ReactNode} children - Texto do divider
 */
const Divider = ({ orientation = 'left', children, ...props }) => {
  return (
    <AntDivider orientation={orientation} {...props}>
      {children}
    </AntDivider>
  );
};

export default Divider;



